import { ActionType } from "store/types";
import { SetJobsFeedData } from "store/jobsFeed/jobsFeed.types";

// ============================== Redux Actions ==============================

export const setJobsFeedData: SetJobsFeedData = (jobsFeedData) => ({
  type: ActionType.SetJobsFeedData,
  payload: jobsFeedData,
});
